import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {environment} from '../../environments/environment';
import type {ChangePassword} from '@shared/components';
import {Observable} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class AuthenticationService {
    private httpClient = inject(HttpClient);

    changePassword(password: ChangePassword) {
        return this.httpClient.patch(`${environment.API_ROOT_PATH}user/password`, password);
    }

    login(username: string, password: string, code: string) {
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded'});
        const params = code ? new HttpParams().set('totp_code', code) : new HttpParams();
        return this.httpClient.post(environment.API_ROOT_PATH + 'auth/token', `password=${encodeURIComponent(password)}&username=${encodeURIComponent(username)}`, {
            headers,
            params,
            withCredentials: true
        });
    }

    getGoogleAuthQR(ticket: string) {
        const params = new HttpParams().set('ticket', ticket);
        return this.httpClient.get(`${environment.API_ROOT_PATH}auth/setup-totp`, {responseType: 'blob', params})
    }

    refreshToken(): Observable<any> {
        return this.httpClient.post(`${environment.API_ROOT_PATH}auth/refresh`, {}, {withCredentials: true});
    }
}
